import React, { Component } from "react";
import styles from "../SchedaSpecialeArbovirosi.module.css";
import Calendar from "../../../../../../../components/calendar/Calendar";
import Autocomplete from "../../../../../../../components/autocomplete/Autocomplete";
import Input from "../../../../../../../components/textbox/Input"; 
import RadioButton from "../../../../../../../components/radiobutton/RadioButton";
import Utils from "../../../../../../../utils/Utils";
import { withTranslation } from "react-i18next";
import OggettiUtili from "../../../../../../../utils/OggettiUtili.json";

class DatiPazienteSemplificati extends Component {
    state = {
        datiAnagraficiPaziente: {
            cognomePaziente: "",
            nomePaziente: "",
            dataDiNascita: "",
            sesso: "",
            comuneResidenza: "",
            corretto: []
        },
        comuni: JSON.parse(sessionStorage.getItem("comuniPerCodice")) || [],
        
    };

    constructor(props) {
        super(props);

        this.state = {
            datiAnagraficiPaziente: {
                cognomePaziente: "",
                nomePaziente: "",
                dataDiNascita: "",
                sesso: "",
                comuneResidenza: "",
                corretto: []
            },
            regioni: OggettiUtili.Regioni,
            province: JSON.parse(sessionStorage.getItem("province")),
            nazioni: JSON.parse(sessionStorage.getItem("nazioni")),
            comuni: Utils.distinctComuni(JSON.parse(sessionStorage.getItem("comuni")), new Date()),
            nazioniPerCodice: JSON.parse(sessionStorage.getItem("nazioniPerCodice")),
            comuniPerCodice: JSON.parse(sessionStorage.getItem("comuniPerCodice")),
            provincePerCodice: JSON.parse(sessionStorage.getItem("provincePerCodice")),
        };

        this.riceviValore = this.riceviValore.bind(this);
        this.aggiornaPadre = this.aggiornaPadre.bind(this);
    }

    componentDidMount() {
        if (
            this.props.segnalazioneCopia?.schedaSpeciale?.datiAnagraficiPaziente
        ) {
            // Carica dati salvati nella scheda speciale
            let pazienteAttuale = JSON.parse(JSON.stringify(
                this.props.segnalazioneCopia.schedaSpeciale.datiAnagraficiPaziente
            ));
            if (pazienteAttuale.comuneResidenza) {
                pazienteAttuale.comuneResidenza =
                    this.state.comuniPerCodice[pazienteAttuale.comuneResidenza]? this.state.comuniPerCodice[pazienteAttuale.comuneResidenza] : this.state.nazioniPerCodice[pazienteAttuale.comuneResidenza]? this.state.nazioniPerCodice[pazienteAttuale.comuneResidenza] : "";
            }
            this.setState({ datiAnagraficiPaziente: pazienteAttuale }, () => this.aggiornaPadre());
        } else {
            // Carica dai dati anagrafici del wizard: se assente → ANONIMO (come Tubercolosi)
            const dp = this.props.datiPaziente || {};
            this.setState({
                datiAnagraficiPaziente: {
                    ...this.state.datiAnagraficiPaziente,
                    nomePaziente:   dp.nomePaziente   || "",
                    cognomePaziente: dp.cognomePaziente || "",
                    dataDiNascita:  dp.dataDiNascita  || "",
                    sesso:          dp.sesso          || "",
                    comuneResidenza: dp.comuneResidenza || ""
                }
            }, () => this.aggiornaPadre());
        }
    }

    riceviValore(field, value) {
        const newValue = value && value.target ? value.target.value : value;

        this.setState(prevState => {
            const nuovo = {
                ...prevState.datiAnagraficiPaziente,
                [field]: newValue
            };

            return {
                datiAnagraficiPaziente: {
                    ...nuovo,
                    corretto: this.controlloCorrettezza(nuovo)
                }
            };
        }, this.aggiornaPadre);
    }

    controlloCorrettezza() {
        let dati = this.state.datiAnagraficiPaziente;
        dati.corretto = [];


        if (!dati.cognomePaziente) {
            dati.corretto[0] = "Cognome obbligatorio";
        }

        if (!dati.nomePaziente) {
            dati.corretto[1] = "Nome obbligatorio";
        }

        if (!dati.dataDiNascita) {
            dati.corretto[2] = "Data di nascita obbligatoria";
        }

        if (!dati.sesso) {
            dati.corretto[3] = "Sesso obbligatorio";
        }
    }

    aggiornaPadre() {
        this.controlloCorrettezza();

        if (this.props.controlloCorrettezza) {
            this.props.controlloCorrettezza();
        }
        let copia = JSON.parse(JSON.stringify(this.state.datiAnagraficiPaziente));

        if (copia.comuneResidenza && copia.comuneResidenza.codice) {
            copia.comuneResidenza = copia.comuneResidenza.codice;
        }

        let oggettoBE = Utils.removeEmptyValueFromObject(copia);
        let oggettoBESenzaCorretto = Utils.removeFieldFromObject(oggettoBE, "corretto");

        const validateStr = copia.corretto && copia.corretto.length > 0
            ? copia.corretto.find(msg => msg) || ""
            : "";


        if (this.props.setDatiAnagraficiPaziente) {
            this.props.setDatiAnagraficiPaziente(
                this.state.datiAnagraficiPaziente,
                validateStr,
                oggettoBESenzaCorretto
            );
        }
    }

    render() {
        const { t } = this.props;
        const { datiAnagraficiPaziente, comuni } = this.state;

        return (
            <div className={"container"}>
                <div style={{marginTop: "10px"}}/>
                <div className="row">
                    <div className="col-lg-4">
                        <p className={styles.labelHeader} style={{ color: "#1b7ea9" }}>
                            {t("DatiSegnalazioneAnagrafici.cognome")}
                            <span className={styles.mandatoryColor}>*</span>
                            {datiAnagraficiPaziente.cognomePaziente !== "ANONIMO"}
                        </p>
                        <Input
                            id="idCognomePaziente"
                            field="cognomePaziente"
                            value={datiAnagraficiPaziente.cognomePaziente}
                            onChange={this.riceviValore}
                            placeholder={"Cognome"}
                        />
                    </div>

                    <div className="col-lg-3">
                        <p className={styles.labelHeader} style={{ color: "#1b7ea9" }}>
                            {t("DatiSegnalazioneAnagrafici.nome")}
                            <span className={styles.mandatoryColor}>*</span>
                            {datiAnagraficiPaziente.nomePaziente !== "ANONIMO"}
                        </p>
                        <Input
                            id="idNomePaziente"
                            field="nomePaziente"
                            value={datiAnagraficiPaziente.nomePaziente}
                            onChange={this.riceviValore}
                            placeholder={"Nome"}
                        />
                    </div>

                    <div className="col-lg-5">
                        <p className={styles.labelHeader} style={{ color: "#1b7ea9" }}>
                            {t("DatiSegnalazioneAnagrafici.comuneResidenza")}
                        </p>
                        <div className={styles.fieldContainer}>
                            <Autocomplete
                                id="idComuneResidenza"
                                field="comuneResidenza"
                                value={datiAnagraficiPaziente.comuneResidenza}
                                keyField="codice"
                                descriptionField="descrizione"
                                suggestionField="descrizione"
                                suggestions={datiAnagraficiPaziente.provinciaResidenza ?
                                    Utils.filtroProvinceComuni(datiAnagraficiPaziente.provinciaResidenza.codice, this.state.comuni, "codiceProvincia") :
                                    this.state.nazioniPerCodice}
                                onChange={this.riceviValore}
                                placeholder={t("DatiSegnalazioneAnagrafici.comuneResidenza")}
                            />
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-lg-4">
                        <p className={styles.labelHeader} style={{ color: "#1b7ea9" }}>
                            {t("DatiSegnalazioneAnagrafici.dataDiNascita")} <span className={styles.mandatoryColor}>*</span>
                        </p>
                        <Calendar
                            id="dataDiNascita"
                            field="dataDiNascita"
                            value={datiAnagraficiPaziente.dataDiNascita}
                            onChange={this.riceviValore}
                            newCalendar={true}
                        />
                    </div>

                    <div className="col-lg-4">
                        <p className={styles.labelHeader} style={{ color: "#1b7ea9" }}>
                            {t("DatiSegnalazioneAnagrafici.sesso")} <span className={styles.mandatoryColor}>*</span>
                        </p>
                        <div className="row">
                            <RadioButton
                                id="sessoM"
                                name="sesso"
                                label="M"
                                value="M"
                                checked={datiAnagraficiPaziente.sesso === "M"}
                                onClick={() => this.riceviValore("sesso", "M")}
                                newRadio={true}
                                smallLabel={true}
                            />
                            <RadioButton
                                id="sessoF"
                                name="sesso"
                                label="F"
                                value="F"
                                checked={datiAnagraficiPaziente.sesso === "F"}
                                onClick={() => this.riceviValore("sesso", "F")}
                                newRadio={true}
                                smallLabel={true}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation("common")(DatiPazienteSemplificati);